

<script>

	import Boxes from './Boxes.svelte'
	import Header from './Header.svelte'
	import Footer from './Footer.svelte'
	import Controllers from './Controllers.svelte'

	export let docDataCuenta = {}

</script>

<div class="background" />

<div class="page">

	<Header />
	<Controllers />
	<Boxes {docDataCuenta} />
	<Footer />

</div>

<style>

	:global(::-webkit-scrollbar) {
		width: 15px;
		height: 15px;
		background-color: transparent; 
	}

	:global(::-webkit-scrollbar-track) {
		box-shadow: none; 
	}

	:global(::-webkit-scrollbar-thumb) {
		background: #2f3037; 
	}

	:global(::-webkit-scrollbar-thumb:hover) {
		background: transparent; 
	}

	.page, .background, :global(body) {
		position: fixed;
		top: 0;
		left: 0;
		margin: 0px;
		width: 100vw;
		height: 100vh;
	}

	:global(body) {
		font-family: "Helvatica", sans-serif !important;
		/*background-color: rgb(0, 47, 70) !important;*/
		background-color: #015774 !important;
	}

	:global(#img-loader) {
		height: 200px;
		position: fixed;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
	}

	.page {
		flex-direction: column;
		overflow: auto;
		display: flex;
		font-size: .9rem;
	}

	.background {
		background-image: url('https://static.wixstatic.com/media/daa8147c90904123b99659c0169c0d91.jpg/v1/fill/w_1903,h_955,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/daa8147c90904123b99659c0169c0d91.jpg');
		background-position: center center;
		background-repeat: no-repeat;
		background-size: cover;
		opacity: .3;
		z-index: -1;
	}

	.page :global(.section-container) {
		margin: 0px auto;
		width: clamp(min(1000px, 100% - 40px), 90vw, 1300px);
	}

</style>

